import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authAPI, searchAPI } from "../../apis";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputPassword from "../../components/input/InputPassword";
import InputText from "../../components/input/InputText";
import {
  emailValidation,
  validateUserPassword,
} from "../../functions/validation";
import {
  setEventName,
  setMicrosoftUser,
  setsidebarData,
} from "../../redux/features/dataSlice";
import { wordpressURL } from "../../config";
import { initAmplitude, logEvent } from "../../functions/amplitude";
import { useSelector } from "react-redux";
import GoogleImg from "../../media/images/google_icon.svg";
import OfficeImg from "../../media/images/microsoft-logo.png";
import CleverImg from "../../media/images/clever_icon.svg";
import ClassLinkImg from "../../media/images/ClassLink.svg";

import { loginUser } from "../../redux/features/authSlice";
import { useGoogleLogin } from "@react-oauth/google";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../msal";

const SignupForm = () => {
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [username, setUsername] = useState("");
  const [tc, settc] = useState(true);
  const [loading, setloading] = useState(false);
  const [errorText, setErrorText] = useState("");

  const { instance, accounts, inProgress } = useMsal();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qrId = queryParams.get("eventName");
  const invitationCode = queryParams.get("invitationCode");
  const decodedInvitationCode = invitationCode
    ? invitationCode.replaceAll(" ", "+")
    : "";
  const { eventName } = useSelector((state) => state.data);

  async function onSubmitLogin(e) {
    e.preventDefault();
    if (!emailValidation(email)) {
      toast.error("Please enter a valid E-mail");
      return;
    }
    if (!validateUserPassword(password)) {
      toast.error("Please enter a valid password");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Password do not match");
      return;
    }
    try {
      setloading(true);
      let url;
      if (eventName) {
        url = `${authAPI.register}?eventName=${eventName}`;
      } else {
        url = authAPI.register;
      }
      const res = await axios.post(url, {
        email,
        password,
        confirmPassword,
        firstName,
        lastName,
        username: email,
        acceptTermsAndConditions: tc,
        invitationCode: String(decodedInvitationCode),
      });
      initAmplitude(res.data.userId);
      logEvent("user_registered", { email: email });
      setloading(false);

      if (res.data) {
        localStorage.setItem("email", email);
        navigate("/SignUpMessage");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data);
      setloading(false);
    }
  }

  const handleCustomMicrosoft = () => {
    instance.loginPopup(loginRequest).catch((e) => {
      console.log(e);
    });
  };

  const handleExternalMicrosoftLogin = async (token, provider) => {
    try {
      setloading(true);
      const res = await axios.post(`${authAPI.microsoftLogin}`, {
        accessToken: token,
        provider: provider,
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      setSidebar(res.data);

      dispatch(loginUser({ user: res.data }));
      localStorage.setItem("email", res.data.email);
      dispatch(setMicrosoftUser(true));

      setloading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const setSidebar = async (data) => {
    try {
      const sidebar = await axios.post(
        searchAPI.sidebar,
        {
          callingUserId: data.userId,
          userId: data.userId,
          includeDeletedRecords: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${data.token}`,
          },
        }
      );

      dispatch(setsidebarData(sidebar.data));
    } catch (e) {
      console.log(e);
    }
  };

  const handleExternalLogin = async (token, provider) => {
    try {
      setloading(true);
      const res = await axios.post(`${authAPI.googleLogin}`, {
        token: token,
        provider: provider,
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      setSidebar(res.data);

      dispatch(loginUser({ user: res.data }));
      localStorage.setItem("email", res.data.email);

      setloading(false);
    } catch (e) {
      console.log(e);
    }
  };
  const redirectToCleverOAuth = () => {
    const clientId = process.env.REACT_APP_API_PROD_CLEVER_CLIENTID;
    const redirectUri = encodeURIComponent(
      "https://app.sooth.fyi/signin/clever"
    );
    const cleverAuthUrl = `https://clever.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
    window.location.href = cleverAuthUrl;
  };

  const redirectToClasslinkOAuth = () => {
    const clientId = process.env.REACT_APP_API_PROD_CLASSLINK_CLIENTID;
    const redirectUri = encodeURIComponent(
      "https://app.sooth.fyi/signin/classlink"
    );
    const classLinkUrl = `https://launchpad.classlink.com/oauth2/v2/auth?scope=profile&redirect_uri=${redirectUri}&client_id=${clientId}&response_type=code`;
    window.location.href = classLinkUrl;
  };

  useEffect(() => {
    const handleResponse = (response) => {
      console.log(accounts);

      if (accounts.length > 0) {
        const account = accounts[0];
        const request = {
          scopes: ["user.read"],
          account: account,
        };
        instance
          .acquireTokenSilent(request)
          .then((accessTokenResponse) => {
            handleExternalMicrosoftLogin(
              accessTokenResponse.accessToken,
              "Microsoft"
            );
          })
          .catch((error) => {
            if (
              error.name === "InteractionRequiredAuthError" ||
              error.message.includes("interaction required")
            ) {
              instance.acquireTokenRedirect(request);
            } else {
              console.error(error);
            }
          });
      }
    };
    handleResponse();

    instance.handleRedirectPromise(() => {});
  }, [instance, accounts]);

  const login = useGoogleLogin({
    onSuccess: async (respose) => {
      handleExternalLogin(respose.access_token, "Google");
    },
  });

  const handleClick = (event, href, term) => {
    event.preventDefault();
    logEvent(`click_footer_${term}`, { [term]: "clicked" });
    window.open(href, "_blank", "noopener noreferrer");
  };

  const Terms1 = () => {
    return (
      <p className="terms terms-placement">
        By signing up to Sooth.fyi, you agree to our{" "}
        <a
          href={`${wordpressURL}/terms-of-use/`}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/terms-of-use/`, "terms");
          }}
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a
          href={`${wordpressURL}/privacy/`}
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/privacy/`, "privacy");
          }}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        .
      </p>
    );
  };

  const Terms2 = () => {
    return (
      <p className="terms">
        By clicking Continue, you agree to Sooth’s{" "}
        <a
          href={`${wordpressURL}/terms-of-use/`}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/terms-of-use/`, "terms");
          }}
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a
          href={`${wordpressURL}/privacy/`}
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/privacy/`, "privacy");
          }}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        .
      </p>
    );
  };

  useEffect(() => {
    if (qrId) {
      dispatch(setEventName(qrId));
    }
  }, [qrId]);

  return (
    <form onSubmit={onSubmitLogin}>
      <div className="sign-up-form">
        <div className="top-box">
          <h1>Sign Up</h1>
          {/*  <h2>Use Single Sign On</h2> */}
          <p className="center terms">
            Use your preferred service to get started immediately
          </p>
          <div className="signinIcons">
            <div className="icon-col" onClick={login}>
              <img alt="sign in with account" src={GoogleImg} />
              <h5>Google</h5>
            </div>

            <div className="icon-col" onClick={handleCustomMicrosoft}>
              <img alt="sign in with account" src={OfficeImg} />
              <h5>Microsoft</h5>
            </div>
            <div className="icon-col" onClick={redirectToCleverOAuth}>
              <img
                alt="sign in with account"
                src={CleverImg}
                className="integrationLogo"
              />
              <h5>Clever</h5>
            </div>
            <div className="icon-col" onClick={redirectToClasslinkOAuth}>
              <img
                alt="sign in with account"
                src={ClassLinkImg}
                className="integrationLogo"
              />
              <h5>ClassLink</h5>
            </div>
          </div>

          <Terms1 />

          <div className="flex" style={{ marginBottom: "10px" }}>
            <div className="divider divider-or-left"></div>
            <div className="or-text">or</div>
            {/* Divider at the Right End of "or" */}
            <div className="divider divider-or-right"></div>
          </div>

          {/* <h2>Create your account</h2> */}
        </div>
        <div className="credentials">
          <div className="flex-gap">
            <InputText
              placeholder="Email address (Required)"
              validation="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
            />
          </div>

          <p className="message">
            NOTE: Password should be minimum 8 characters with at least one
            uppercase letter, one lowercase letter, one special character and
            one number.
          </p>
          <InputPassword
            placeholder="Password (Required)"
            value={password}
            onChange={(e) => setpassword(e.target.value)}
          />
          <InputPassword
            placeholder="Confirm password (Required)"
            value={confirmPassword}
            onChange={(e) => setconfirmPassword(e.target.value)}
          />

          <Terms2 />
          <ButtonPrimary text="Continue" loading={loading} />
          <ButtonPrimary
            text="Back to Home"
            onClick={() =>
              (window.location.href =
                process.env.REACT_APP_PRODUCTION_POLICY_URL)
            }
          />
        </div>
      </div>
    </form>
  );
};

export default SignupForm;
